<template>
  <div class="ui small modal" id="newReservationModal">
    <i class="close icon"></i>
    <div class="header">
      Add Reservation
    </div>
    <div class="content">

      <p>To add reservation, enter contact details</p>

      <div class="ui top attached segment">
        <form class="ui contact-details form" v-on:submit.prevent="reserve">
          <div class="two fields">
            <div class="field">
              <label>Number of People</label>
              <input type="number" name="numPeople" v-model="details.numPeople" placeholder="Enter number">
            </div>
            <div class="field">
              <label>Select reason</label>
              <select class="ui selection dropdown" name="reason" v-model="details._reason">
                <option value="">Select</option>
                <option :value="reason._id" v-for="reason in reasons">{{ reason.title }}</option>
              </select>
            </div>
          </div>
          <div class="service list item" v-for="additionalService in additionalServices">
            <div class="icon">
              <i class="large green checkmark icon" :class="{'green checkmark': additionalService.selected, 'grey delete': !additionalService.selected}"></i>
            </div>
            <div class="content">
              {{ additionalService.title }}
              <br>
              <span style="font-size: 12px">
                            {{ additionalService.description }}
                          </span>
            </div>
            <div class="price">
              <span :class="{ 'strong': additionalService.selected }">€ {{ numeral(additionalService.price).format('0,0.00') }}<span v-if="additionalService.priceType === 'perPerson'"> / person</span></span>
            </div>
            <div class="select">
              <div class="ui basic tiny buttons">
                <div class="ui button" @click="toggleService(additionalService)" v-if="!additionalService.selected"><i class="checkmark icon"></i> Select</div>
                <div class="ui button" @click="toggleService(additionalService)" v-else><i class="delete icon"></i> Remove</div>
              </div>
            </div>
          </div>
          <div class="field" style="margin-top: 15px">
            <label>Additional wishes</label>
            <textarea name="wishes" v-model="details.wishes" rows="2" placeholder="Specify additional wishes to track"></textarea>
          </div>
          <div class="field">
            <label>Additional questions</label>
            <textarea name="questions" v-model="details.questions" rows="2" placeholder="Specify additional questions to track"></textarea>
          </div>
          <div class="field">
            <label>Voucher</label>
            <div class="ui right icon input">
              <input type="text" name="voucher" v-model="details.voucher" placeholder="Enter voucher">
              <i class="barcode icon"></i>
            </div>

          </div>

          <div>
          <div class="ui positive message" v-if="voucher">
            <p>A discount of
              <strong>
                <span v-if="voucher.deduct.percentage > 0">-{{ voucher.deduct.percentage * 100}}%</span>
                <span v-if="voucher.deduct.percentage > 0 && voucher.deduct.absolute > 0"> and </span>
                <span v-if="voucher.deduct.absolute > 0">-{{ voucher.deduct.absolute }}.00€</span>
              </strong>
              is applied to this booking.
            </p>
          </div>
          </div>

          <div class="field">
            <label>Title</label>
            <select class="ui selection dropdown" name="title" v-model="contact.title">
              <option value="">Select</option>
              <option value="Herr">Herr</option>
              <option value="Frau">Frau</option>
              <option value="Dr">Dr</option>
              <option value="Prof">Prof</option>
              <option value="Mag">Mag</option>
            </select>
          </div>

          <div class="two fields">
            <div class="field">
              <label>First Name</label>
              <input type="text" name="firstName" v-model="contact.firstName">
            </div>
            <div class="field">
              <label>Last Name</label>
              <input type="text" name="lastName" v-model="contact.lastName">
            </div>
          </div>
          <div class="field">
            <label>Company</label>
            <input type="text" name="company" v-model="contact.company">
          </div>
          <div class="field">
            <label>Email</label>
            <input type="text" name="email" v-model="contact.email">
          </div>
          <div class="field">
            <label>Telephone</label>
            <input type="text" name="tel" v-model="contact.tel">
          </div>
          <div class="field">
            <label>Address</label>
            <input type="text" name="address" v-model="contact.address">
          </div>
          <div class="fields">
            <div class="ten wide field">
              <label>City</label>
              <input type="text" name="city" v-model="contact.city">
            </div>
            <div class="six wide field">
              <label>Post Code</label>
              <input type="text" name="zip" v-model="contact.zip">
            </div>
          </div>
        </form>
      </div>
      <table class="ui bottom attached basic table">
        <tbody>
        <tr v-for="booking in selected">
          <td>
            {{ booking.boat.name }}
          </td>
          <td>
            {{ booking.hour }} h
          </td>
          <td>
            {{ moment(booking.date).format('ll') }}
          </td>
          <td class="right aligned">
            €{{ booking.cost }}.00
          </td>
        </tr>
        <tr v-for="service in additionalServices" v-if="service.selected">
          <td colspan="3">
            {{ service.title }} <span v-if="service.priceType === 'perPerson' && details.numPeople">x{{ details.numPeople }}</span>
          </td>
          <td class="right aligned">
            <span v-if="service.priceType === 'perPerson' && details.numPeople">€{{ numeral(service.price * details.numPeople).format('0,0.00') }}</span>
            <span v-else>€{{ numeral(service.price).format('0,0.00') }}</span>
          </td>
        </tr>
        <tr v-if="voucher">
          <td colspan="4"><strong>Voucher:</strong> {{ voucher.code }}</td>
        </tr>
        <tr v-if="voucher && voucher.deduct.absolute > 0">
          <td colspan="3"></td>
          <td class="right aligned">- €{{ voucher.deduct.absolute }}.00</td>
        </tr>
        <tr v-if="voucher && voucher.deduct.percentage > 0">
          <td colspan="3"></td>
          <td class="right aligned">- {{ voucher.deduct.percentage * 100 }}%</td>
        </tr>
        </tbody>
        <tfoot>
        <tr>
          <th colspan="3"><strong>Total</strong></th>
          <th class="right aligned">
            <strong>€{{ totalCost }}</strong>
          </th>
        </tr>
        </tfoot>
      </table>

    </div>
    <div class="actions">
      <div class="ui icon cancel button">
        <i class="delete icon"></i> Close
      </div>
      <div class="ui positive button" @click="reserve">
        <i class="checkmark icon"></i> Add Reservation
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import * as services from './../../services/'

  export default {
    data() {
      return {
        moment: moment,
        'contact': {
          'firstName': "",
          'lastName': "",
          'email': "",
          'address': "",
          'city': "",
          'zip': "",
          'tel': "",
          'termsAccepted': false,
          'comments': "",
        },
        'details': {
          'numPeople': null,
          'voucher': null,
          'wishes': null,
          'questions': null,
          '_reason': null,
          'reason': null,
          'services': []
        },
        'voucher': null,
        'reasons': [],
        'additionalServices': [],
        'numeral': numeral,
        'submitting': false
      }
    },
    mounted() {
      services.reasonService.find({}).then(reasons => {
        this.reasons = reasons.data
      })

      services.additonalServiceService.find({}).then(services => {
        this.additionalServices = services.data
      })

      $('#newReservationModal').modal()
    },
    computed: {
      totalCost() {
        let price = 0

        const cost = this.selected.map((item) => {
          return item.cost
        })

        if (cost.length > 0) {
          price = cost.reduce((a, b) => { return a+b })
        }

        for (let service of this.additionalServices) {
          if (service.selected) {
            if (service.priceType === 'perPerson') price = price + (this.details.numPeople || 0) * Number(service.price)
            else price = price + Number(service.price);
          }

        }

        if (price === 0) return 0

        if (this.voucher && this.voucher.deduct.absolute) price = price - this.voucher.deduct.absolute
        if (this.voucher && this.voucher.deduct.percentage) price = (1 - this.voucher.deduct.percentage) * price

        return numeral(price).format('0,0.00')
      },
      user() {
        if (!this.$store.state.user) return null;

        return this.$store.state.user.data._id;
      }
    },
    watch: {
      selected: function () {
        $('newReservationModal').modal('refresh')
      },
      'details.voucher': _.debounce(
        function () {
          services.voucherService.find({ query: { code: this.details.voucher, $limit: 1 }}).then(vouchers => {
            if (vouchers.data[0]) this.voucher = vouchers.data[0]
          })
        }, 500
      ),
      'details._reason': function () {
        if (this.details._reason) this.details.reason = this.reasons.find(reason => { return reason._id === this.details._reason })['title']
      }
    },
    methods: {
      reserve() {
        if (this.submitting) return

        this.submitting = true

        let reservation = {
          'contact': this.contact,
          'parsedTel': this.contact.tel ? this.contact.tel.replace(/[^1-9]/, '') : "",
          '_bookings': this.selected.map((booking) => {return booking._id}),
          'confirmed': true,
          'allBookings': this.selected,
          'wishes': this.details.wishes,
          'questions': this.details.questions,
          '_reason': this.details._reason,
          'reason': this.details.reason,
          'services': this.additionalServices.filter(service => {return service.selected}),
          'people': this.details.numPeople,
          'discount': this.voucher ? { 'absolute': this.voucher.deduct.absolute, 'percentage': this.voucher.deduct.percentage, 'voucher': this.voucher.code } : null,
          'user': this.user
        }

        services.reservationService.create(reservation).then((createdReservations) => {
          this.$emit('reservationCreated')
          toastr.success(`Reservation was successfully created for <strong>${this.contact.firstName} ${this.contact.lastName}</strong>`, 'Reservation Created!')
          this.contact['firstName'] = null
          this.contact['lastName'] = null
          this.contact['email'] = null
          this.contact['company'] = null
          this.contact['title'] = null
          this.contact['terms'] = false
          this.contact['address'] = null
          this.contact['city'] = null
          this.contact['zip'] = null
          this.contact['tel'] = null
          this.details = {
            'numPeople': null,
            'voucher': null,
            'wishes': null,
            'questions': null,
            'reason': null,
            'services': []
          }
          for (let service of this.additionalServices) {
            service.selected = false
          }

          this.submitting = false
        }).catch(error => {
          this.submitting = false

          toastr.error(error, 'Error submitting reservation!')

          throw error
        })
      },
      toggleService(service) {
        if (!('selected' in service)) service.selected = true
        else service.selected = !service.selected

        this.additionalServices.splice(this.additionalServices.findIndex((addService) => {return addService._id === service._id }), 1, service)
      },
    },
    props: [
      'selected'
    ]
  }
</script>

<style scoped>
  .service.list.item {
    display: flex;
    flex-flow: nowrap;
    border-bottom: 1px solid #eeeeee;
    padding: 8px 0;
  }
  .service.list.item .content {
    flex-grow: 1;
  }
  .service.list.item .select {
    margin-left: 30px;
  }
  .service.list.item .price {
    font-size: 13px;
    padding-top: 6px;
  }
  .service.list.item .icon {
    margin: 0 10px;
    align-self: center;
  }

</style>



// WEBPACK FOOTER //
// NewReservationModal.vue?3ac33b5d